import { Component, OnInit } from '@angular/core';
import { CaseComponent } from '../../components/case-base/case.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { CaseService } from '@app/core/services/case.service';
import { AddressParticipantOptions } from '@app/modules/case/components/address-participant/address-participant.component';
import { ParticipantTypes } from '@app/shared/models/participant-type';
import { DateTimePickerOptions } from '@app/shared/components/date-time-picker/date-time-picker.component';
import { FileType } from '@app/shared/models/file-type';
import { CaseFileCategory } from '@app/shared/models/case-file-category';
import { DrFileMetaCategoryList } from '@app/shared/models/dr-file';
import { ContentStoreService } from '@app/core/services/content-store.service';


@Component({
  templateUrl: './case-detailed-accident-description.component.html',
  styleUrls: ['./case-detailed-accident-description.component.scss']
})
export class CaseDetailedAccidentDescriptionComponent extends CaseComponent implements OnInit {

  public addressParticipantType = ParticipantTypes.ACCIDENT_LOCATION.key;
  public addressParticipantOptions: AddressParticipantOptions[];
  public claimDateTimePickerOptions: DateTimePickerOptions;
  public damageTypes: string[];
  public fileMetaCategoryList: DrFileMetaCategoryList;
  public acceptedFileTypes: FileType[];
  public accidentDocumentCategory = CaseFileCategory.ACCIDENT_DOCUMENT.key;
  public claimImageCategory = CaseFileCategory.CLAIM_IMAGE.key;

  constructor(protected componentServiceBundle: ComponentServiceBundle,
              protected caseService: CaseService,
              protected contentStoreService: ContentStoreService) {
    super(componentServiceBundle, caseService);
    this._idPrefix = 'case_detailed_accident_description.';
  }

  public ngOnInit() {
    super.ngOnInit();

    this.addressParticipantOptions = [
      AddressParticipantOptions.ADDRESS,
      AddressParticipantOptions.COUNTRY,
      AddressParticipantOptions.COMMENT
    ];

    this.damageTypes = [
      'collision',
      'parking',
      'driveways',
      'animal',
      'total_theft',
      'storm_hail_damage',
      'right_before_left',
      'vehicle_breakdown',
      'theft',
      'fire_damage',
      'glass_damage',
      'lane_change',
      'miscellaneous'
    ];

    this.acceptedFileTypes = []; // FileTypes.ALL;
  }

  private orderCaseFileMetaList(): void {
    if (this.fileMetaCategoryList) {
      this.fileMetaCategoryList.sortAllFileMetaDatabyOrder();
    }
  }

  protected whenOriginalFetched(): void {
    super.whenOriginalFetched();

    this.claimDateTimePickerOptions = {
      datePatchPath: 'claim_date',
      timePatchPath: 'claim_date_usertime',
      dateLabel: this.case.trans.claim_date,
      timeLabel: this.case.trans.claim_date_usertime
    };

    this.contentStoreService.getCaseFileMetaList(this.case, [this.accidentDocumentCategory, this.claimImageCategory])
        .subscribe((result: DrFileMetaCategoryList) => {
            this.fileMetaCategoryList = result;
            this.orderCaseFileMetaList();
          },
          err => this.handleError(err)
        );
  }

}
